import { Button, TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import SelectMenuItem from "./Component/SelectMenuItem";
import { CallStatus, LogMediums } from "./Utils/SelectInputLabel";
import { TiTick } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerLogs } from "../../../store/async-actions/digitalmarketing/customer";
import { useAddCustomerLogMutation } from "../../../Service/CustomerLogs";
import { specialChractorValidation } from "./Utils/validation";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";

function AddLogs({ setadd, callBackforErrorMessage, openSnackBar,view }) {
  // console.log(view);
  
  const dispatch = useDispatch<any>();
  const CustomerDetail = useSelector((state: any) => state.customer.customerDetail);
  const [addCustomerLog,{ isLoading:addLoading }] = useAddCustomerLogMutation()
  const getValueByLabel = (obj, label) => {
    let val = obj.find(item => item.label == label)
    if (val) {
      return val.value
    }
    return undefined
  }
  const getLabelByValue = (obj, value) => {
    let val = obj.find(item => item.value == value)
    if (val) {
      return val.label
    }
    return undefined
  }
  const initialstate = {
    date: "",
    time: "11",
    medium: "",
    status: "",
    comments: "",
  };
  const [selectedValue, setSelectedValue] = useState<any>(initialstate);
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setSelectedValue((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleDateChange = (name, value) => {
    setSelectedValue((prev) => {
      return { ...prev, [name]: value };
    });
  }
  const handler = () => {
    if (CustomerDetail.customerName.trim().length && !specialChractorValidation(CustomerDetail.customerName)) {
      if (CustomerDetail.id && ((getLabelByValue(LogMediums, selectedValue.medium) || getLabelByValue(CallStatus, selectedValue.status)) &&selectedValue.comments)) {
        addCustomerLog({ "customerId": CustomerDetail.id, "medium": getLabelByValue(LogMediums, selectedValue.medium), "status": getLabelByValue(CallStatus, selectedValue.status), "comments": selectedValue.comments })
        setadd(false);

      }else{
       openSnackBar("Please fill atleast one before submit!", "error")
      }
    }
    else {
      openSnackBar(callBackforErrorMessage(), "error")
    }
  };
  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell align="left">
        <SelectMenuItem
          styles={"select-custom"}
          option={LogMediums}
          view={view}

          name="medium"
          value={selectedValue.medium}
          onChange={handleSelectChange}
        />
      </TableCell>
      <TableCell align="left">
        <SelectMenuItem
          styles={"select-custom"}
          option={CallStatus}
          name="status"
          view={view}
          value={selectedValue.status}
          onChange={handleSelectChange}
        />
      </TableCell>
      <TableCell align="left">
        <input type="text" name="comments" disabled={view} onChange={handleSelectChange} />
      </TableCell>
      <TableCell align="left">
        <Button disabled={view||addLoading}  variant="contained" id="btn-blue" onClick={handler}>
          <TiTick style={{ marginTop: "-2px" }} />
        </Button>
      </TableCell>
    </TableRow>
  );
}

export default React.memo(AddLogs);
